/* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any */
import { ref as vueRef } from 'vue';

export const Ref: PropertyDecorator = (target, property) => {
  const ref = vueRef((target as any)[property]);

  Object.defineProperty(target, property, {
    get() {
      return ref.value;
    },
    set(newValue) {
      ref.value = newValue;
      return newValue;
    },
  });
};
